/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import AppConst from '../constants/app.constant';
import ConfigDeviceSettings from '../config/device.config';
import { getIsLoggedIn } from './user/getIsLoggedIn';

const authGuardService = () => {
  const content = {};
  content.checkIsAirportTabAllowed = (actionKey) => {
    let isActionAllowed = true;
    if (AppConst.allowedAirportTabs.indexOf(actionKey) === -1) {
      isActionAllowed = false;
    }
    return isActionAllowed;
  };
  content.checkIfRouteIsAllowed = (to) => {
    let isRouteAllowed = false;
    const shouldRedirectTo = '/app/login';
    if (to.name === 'app.login' || to.name === 'app.authSuccess' || to.name === 'app.developer') {
      isRouteAllowed = true;
    } else if (ConfigDeviceSettings.settings.enableLoginFlow) {
      isRouteAllowed = getIsLoggedIn();
    } else {
      isRouteAllowed = true;
    }
    return { isRouteAllowed, shouldRedirectTo };
  };
  return content;
};
export default authGuardService();
